// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import RegionStatus from "./region_status_type";


export default __t.row({
  id: __t.string().primaryKey(),
  displayName: __t.string().name("display_name"),
  wsUrl: __t.string().name("ws_url"),
  httpUrl: __t.string().name("http_url"),
  get status() {
    return RegionStatus;
  },
  sortOrder: __t.u8().name("sort_order"),
  updatedAt: __t.u64().name("updated_at"),
});
